import React, { useState } from "react";
import { useEffect } from "react";
import { Icon } from "@iconify/react";
import { useHistory } from "react-router-dom";
import { useRef } from "react";
import { useSearchBooksManager } from "../../hooks/advanced-search/use-search-manager";
import { useAdvancedSearch } from "../../hooks/advanced-search/use-advanced-search";
import useObtenerSubsecciones from "../../js/translations/useObtenerSubsecciones";
import _ from "lodash";
import { useId } from "../../hooks/use-id";

/**
 * Componente que contiene el input de búsqueda y que  se encarga de mostrar el listado de coincidencias al escribir en el input y de redirigir a la sección de búsqueda en donde muestra las coincidencias encontradas.
 * @returns {React.Component}
 */
export const SearchInput = () => {
    const {textosSubSecciones:textos} = useObtenerSubsecciones('busqueda_avanzada');
    const [text, setText] = useState('');
    const [shouldShowMatchesList, setShouldShowMatchesList] = useState(false);
    const searchManager = useSearchBooksManager({ text });
    const matches = Array.isArray(searchManager?.matches) ? searchManager?.matches : [];
    const history = useHistory();
    const advancedSearchManager = useAdvancedSearch();
    const formRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(-1);
    const controlsId = useId("matches-list");

    const onSubmit = (e) => {
        e.preventDefault();
        search(text);
    }

    const search = (_text) => {
        history.push({
            pathname: '/busqueda',
            search: `?sch=${encodeURIComponent(_text)}`,
            state:{forceSearchByParams:true}
        })
        advancedSearchManager.setVisible(false);
        setText('')
    }

    useEffect(() => {
        setShouldShowMatchesList(true);
    }, [text])

    useEffect(()=>{
        const isVisible = advancedSearchManager?.state?.visible;
        if(!isVisible){
            setText('');
        }
    },[advancedSearchManager?.state?.visible])


    useEffect(() => {
        let timer = null;
        const handleClickOutside = (event) => {
            if (formRef.current && !formRef.current.contains(event.target)) {
                timer = setTimeout(() => {
                    setShouldShowMatchesList(false);
                }, 70);
            } else {
                setShouldShowMatchesList(true);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            clearTimeout(timer)
        };
    }, [formRef]);

    const handleKeyDown = (e) => {
        if (!shouldShowMatchesList) return;

        if (e.key === "ArrowDown") {
            e.preventDefault();
            setActiveIndex((prev) =>
                prev < matches.length - 1 ? prev + 1 : 0
            );
        }

        if (e.key === "ArrowUp") {
            e.preventDefault();
            setActiveIndex((prev) =>
                prev > 0 ? prev - 1 : matches.length - 1
            );
        }

        if (e.key === "Enter" && activeIndex >= 0) {
            e.preventDefault();
            search(matches[activeIndex].title);
        }

        if (e.key === "Escape") {
            setShouldShowMatchesList(false);
        }
    };

    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === "Escape") {
                setShouldShowMatchesList(false);
            }
        };

        document.addEventListener("keydown", handleKey);
        return () => document.removeEventListener("keydown", handleKey);
    }, []);

    return (<form ref={formRef} className="w-100 d-flex" onSubmit={onSubmit}>
        <div className="search-input-wrapper">

            <label htmlFor="search-input" className="sr-only">{textos?.a11y?.input?.label || "Buscar libros"}</label>
            <input
                id="search-input"
                className="search-input focusable-red"
                value={text}
                placeholder={_.get(textos, `header.input_busqueda.placeholder`) || 'Búsqueda por título, tema, etiqueta, autor, editorial...'}
                onChange={(e) => setText(e?.target?.value)}
                role="combobox"
                aria-autocomplete="list"
                aria-expanded={shouldShowMatchesList}
                aria-controls={controlsId}
                aria-activedescendant={activeIndex >= 0 ? `match-${activeIndex}` : undefined}
                onKeyDown={handleKeyDown}
            />
            {
                shouldShowMatchesList && text && text?.trim().length > 0 &&
                <ul className="matches-list" id={controlsId} role="listbox">
                    {
                        searchManager?.loading ?
                            <>
                                <li className="p-2 w-100 text-center secondary-inverse--color" role="status" aria-live="polite">
                                    <span className="sr-only">{textos?.a11y?.input?.load || "Cargando resultados"}</span>
                                    <Icon icon="icomoon-free:spinner9" width={30} className={'spinner-rotation'} />
                                </li>
                            </>
                            :
                            <>
                                {/* {matches?.length <= 0 &&
                                    <li className="p-2 w-100 text-center onbackground-primary--color font-weight-bold">{_.get(textos, `header.input_busqueda.sin_resultados`) || 'Sin resultados'}</li>
                                } */}
                                {matches?.map((match,i) => {
                                    return <li key={`${match?.title}-${i}`} id={`match-${i}`} role="option" aria-selected={activeIndex === i}>
                                        <button type="button" className="focusable-red match-item"
                                            onClick={() => search(match?.title)}>
                                            {match?.title || 'N/A'}
                                        </button>
                                    </li>
                                })}
                            </>
                    }
                </ul>
            }

            <button className="search-button focusable-red onsecondary--color" type="submit" aria-label={textos?.a11y?.input?.button_search || "Buscar"}>
                <Icon icon="fa:search" className="icon-search-button" />
            </button>

            <button
                type="button"
                aria-label={textos?.a11y?.input?.button_clear || "Limpiar búsqueda"}
                className={`focusable-red clear-button ${text && text?.trim().length > 0 ? 'd-flex' : 'd-none'}`}
                onClick={() => setText('')}>
                <Icon icon="iconamoon:close-bold" className="icon-close-button"/>
            </button>

        </div>
    </form>

    )
}


